import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Field } from '../types/api';
import { fieldsService } from '../services/fieldsService';

interface FieldsState {
  fields: Field[];
  loading: boolean;
  error: string | null;
}

const initialState: FieldsState = {
  fields: [],
  loading: false,
  error: null,
};

// Async thunk for fetching fields
export const fetchFields = createAsyncThunk(
  'fields/fetchFields',
  async (tenantId: string, { rejectWithValue }) => {
    try {
      // Always fetch fresh fields data - no caching
      const response = await fieldsService.getFieldsList(tenantId);
      return response.data;
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to fetch fields';
      return rejectWithValue(errorMessage);
    }
  },
);

const fieldsSlice = createSlice({
  name: 'fields',
  initialState,
  reducers: {
    clearFields: (state) => {
      state.fields = [];
      state.error = null;
    },
    clearFieldsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFields.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFields.fulfilled, (state, action) => {
        state.loading = false;
        state.fields = action.payload;
      })
      .addCase(fetchFields.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearFields, clearFieldsError } = fieldsSlice.actions;
export default fieldsSlice.reducer;
